import { ScenarioStatus, StepStatus } from "../../types/appFlows";

/**
 * Parse Behave log output into structured data
 */
export function parseBehaveLogs(logs = []) {
    const features = [];
    let currentFeature = null;
    let currentScenario = null;

    for (const line of logs) {
        const trimmed = line.trim();

        // Feature: Feature: Login Flow
        const featureMatch = trimmed.match(/^Feature:\s*(.+?)(?:\s*#|$)/);
        if (featureMatch) {
            currentFeature = { name: featureMatch[1].trim(), scenarios: [] };
            features.push(currentFeature);
            currentScenario = null;
            continue;
        }

        // Scenario: Scenario: Valid login
        const scenarioMatch = trimmed.match(/^(?:@[\w-]+\s*)*Scenario:\s*(.+?)(?:\s*#|$)/);
        if (scenarioMatch && currentFeature) {
            const tags = (trimmed.match(/(@[\w-]+)/g) || []).map((t) => t.replace("@", ""));

            currentScenario = {
                name: scenarioMatch[1].trim(),
                tags,
                steps: [],
                status: ScenarioStatus.RUNNING,
            };
            currentFeature.scenarios.push(currentScenario);
            continue;
        }

        // Steps: Given/When/Then
        const stepMatch = trimmed.match(/^(Given|When|Then|And|But)\s+(.+)$/);
        if (stepMatch && currentScenario) {
            const keyword = stepMatch[1];
            let text = stepMatch[2];
            let status = StepStatus.PENDING;

            if (trimmed.includes("passed")) {
                status = StepStatus.PASSED;
                text = text.replace(/\.\.\.\s*passed.*/, "");
            } else if (trimmed.includes("failed") || trimmed.includes("ERROR")) {
                status = StepStatus.FAILED;
                text = text.replace(/\.\.\.\s*failed.*/, "");
            } else if (trimmed.includes("skipped")) {
                status = StepStatus.SKIPPED;
                text = text.replace(/\.\.\.\s*skipped.*/, "");
            }

            currentScenario.steps.push({ keyword, text, status });
            continue;
        }

        // Scenario status
        if (currentScenario) {
            if (trimmed.includes("passed")) currentScenario.status = ScenarioStatus.PASSED;
            if (trimmed.includes("failed") || trimmed.includes("ERROR"))
                currentScenario.status = ScenarioStatus.FAILED;
        }
    }

    // Final status fix
    features.forEach((f) =>
        f.scenarios.forEach((s) => {
            const hasFailed = s.steps.some((x) => x.status === StepStatus.FAILED);
            const allPassed = s.steps.length && s.steps.every((x) => x.status === StepStatus.PASSED);

            if (hasFailed) s.status = ScenarioStatus.FAILED;
            else if (allPassed) s.status = ScenarioStatus.PASSED;
        })
    );

    return features;
}
